/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Sparkles } from 'lucide-react';
import { Card } from '../../ui/Card';

interface SuggestionsProps {
    onSuggestionClick: (suggestion: string) => void;
}

export const Suggestions: React.FC<SuggestionsProps> = ({ onSuggestionClick }) => {
    return (
        <div className="flex flex-col gap-4 h-full">
            <div className="bg-gradient-to-br from-nobel-gold to-[#A08040] rounded-card p-6 text-white shadow-lg relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full blur-2xl transform translate-x-10 -translate-y-10"></div>
                <Sparkles className="text-white mb-3" size={24} />
                <h3 className="font-serif text-xl font-bold mb-2">Pro Tip</h3>
                <p className="text-sm opacity-90 leading-relaxed">
                    You can ask me to "Show revenue from last week" to instantly generate a chart.
                </p>
            </div>

            <Card noPadding className="flex-1">
                <div className="p-4 h-full flex flex-col">
                    <h4 className="text-xs font-bold text-stone-400 uppercase tracking-widest mb-3 px-2">Suggested Actions</h4>
                    <div className="space-y-2 flex-1">
                        {["Create Escrow Contract", "Check Wallet Balance", "Export Sales Report"].map((action, i) => (
                            <button
                                key={i}
                                onClick={() => onSuggestionClick(action)}
                                className="w-full text-left p-3 rounded-btn bg-stone-50 dark:bg-white/5 hover:bg-stone-100 dark:hover:bg-white/10 text-sm text-stone-700 dark:text-gray-300 transition-colors border border-transparent hover:border-stone-200 dark:hover:border-white/10"
                            >
                                {action}
                            </button>
                        ))}
                    </div>
                </div>
            </Card>
        </div>
    );
};